import { useParams } from 'next/navigation'
import { useEffect } from 'react'

import { useTossPaymentWidgetInfo } from '../../api/get-toss-payment-widget-info'
import {
  AGREEMENT_SELECTOR,
  PAYMENT_SELECTOR,
  useTossWidget,
} from '../../lib/toss-widget'

type Params = {
  contractId: string
}

export const PaymentMethod = () => {
  const params = useParams<Params>()
  const contractId = params?.contractId

  const { fetchPaymentWidgets, renderPaymentWidgets } = useTossWidget()

  const { widgetInfo } = useTossPaymentWidgetInfo(Number(contractId))

  useEffect(() => {
    if (widgetInfo) {
      void fetchPaymentWidgets(widgetInfo)
    }
  }, [fetchPaymentWidgets, widgetInfo])

  useEffect(() => {
    void renderPaymentWidgets()
  }, [renderPaymentWidgets])

  return (
    <div>
      <h3 className="typo-body1 p-6 pb-3 text-start font-semibold text-black">
        결제 방법
      </h3>
      <div id={PAYMENT_SELECTOR} />
      <div id={AGREEMENT_SELECTOR} />
    </div>
  )
}

export const PaymentMethodFallback = () => {
  return (
    <div>
      <h3 className="typo-body1 p-6 pb-3 text-start font-semibold text-black">
        결제 방법
      </h3>
      <div className="typo-label1 bg-gray-0 m-6 mt-0 flex h-[200px] items-center justify-center rounded-md text-gray-900">
        결제 정보가 올바르지 않습니다.
        <br />
        다시 시도해 주세요.
      </div>
    </div>
  )
}
